<script>
import {mapActions} from "vuex";
import SearchBlock from './_Search.vue';
import ScheduleBlock from './_Schedule.vue';
import ChoosePeriodModal from './modals/ChoosePeriodModal.vue';

export default {
  name: "DriverSchedules",
  components: {
    SearchBlock,
    ScheduleBlock,
    ChoosePeriodModal,
  },
  mixins: [],
  props: {},
  data() {
    return {
      /** 開始日 */
      startDate: this.$dayjs().format('YYYY-MM-DD'),
      /** 終了日 */
      endDate: null,
      /** 日数 */
      numberOfDays: 2,
      disableDriverIds: [],
      /** ドライバー */
      drivers: [],
      windowSize: {
        x: 0,
        y: 0,
      },
    }
  },
  computed: {
    windowWidth () {
      return this.windowSize.x
    }
  },
  watch: {},
  created() {
    this.buildEndDate();
    this.searchDrivers();
  },
  mounted() {
    // html, bodyに設定されたスクロールを無効化
    document.querySelector('html').style.overflow = 'hidden';
    document.querySelector('body').style.overflow = 'hidden';
    this.onResize()
  },
  beforeDestroy() {
    // html, bodyに設定したスクロールの無効化を戻す
    document.querySelector('html').style.overflow = 'auto';
    document.querySelector('body').style.overflow = 'auto';
  },
  methods: {
    ...mapActions('SearchDriverScheduleDriver', {
      fetchDrivers: 'index',
    }),
    onResize () {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
    },
    /**
     * 再読込ボタン クリックイベント
     */
    reloadButtonClickEvent () {
      this.callSearchBlock()
      this.callScheduleBlock()
    },
    /**
     * ドライバーの日別スケジュールを取得
     */
    choosePeriodCallback (conditions) {
      this.startDate = conditions.baseDate;
      this.numberOfDays = conditions.baseNumberOfDays;
      this.buildEndDate();
    },
    /**
     * 日付ボタンの展開を行うメソッド
     */
    buildEndDate () {
      this.endDate = this.$dayjs(this.startDate).add(this.numberOfDays -1, 'days').format('YYYY-MM-DD');
    },
    /**
     * ドライバーの表示制御
     * @param disableDriverIds { Array } 非表示とするドライバーID
     */
    disableDriverCallback (disableDriverIds) {
      this.disableDriverIds = disableDriverIds;
    },
    /**
     * ドライバー情報の読み込み
     */
    searchDrivers () {
      this.fetchDrivers({without_invisible: true}).then((content) => {
        this.drivers = content.drivers
      });
    },
    /**
     * 左ペイン 受注一覧の再検索
     */
    callSearchBlock () {
      this.$refs.searchBlock.searchSchedules();
    },
    /**
     * 右ペイン ドライバースケジュールの再検索
     */
    callScheduleBlock () {
      this.$refs.scheduleBlock.loadDayOfDriverSchedules();
    },
  },
}
</script>

<template>
  <v-container
    v-resize="onResize"
    fluid
    class="driver-schedule-container"
  >
    <v-row dense class="mb-2">
      <v-col cols="12" md="7" sm="8">
        <h2
          v-if="windowWidth >= 1280"
          class="float-left"
        >
          <v-icon class="mr-2">
            mdi-store-clock-outline
          </v-icon>
          ドライバースケジュール
        </h2>
        <h3
          v-else
          class="float-left"
        >
          <v-icon class="mr-2">
            mdi-store-clock-outline
          </v-icon>
          ドライバースケジュール
        </h3>
        <h2
          v-if="windowWidth >= 1280"
          class="float-left ml-2">
          <span
            class="font-weight-light"
            :class="{
              'subtitle-1': windowWidth >= 1280,
              'subtitle-2': windowWidth < 1280,
             }"
          >（{{ startDate | date_format }}&nbsp;〜&nbsp;{{ endDate | date_format }}）</span>
          <choose-period-modal
            :start-date="startDate"
            :number-of-days="numberOfDays"
            :window-width="windowWidth"
            @changeCallback="choosePeriodCallback"
          />
          <v-btn
            class="ml-2"
            :color="windowWidth < 1280 ? 'primary' : null"
            :icon="windowWidth < 1280"
            :small="windowWidth < 1280"
            @click="reloadButtonClickEvent"
          >
            <v-icon dark>
              mdi-refresh
            </v-icon>
          </v-btn>
        </h2>
        <h3
          v-else
          class="float-left ml-2">
          <span
            class="font-weight-light"
            :class="{
              'subtitle-1': windowWidth >= 1280,
              'subtitle-2': windowWidth < 1280,
             }"
          >（{{ startDate | date_format }}&nbsp;〜&nbsp;{{ endDate | date_format }}）</span>
          <choose-period-modal
            :start-date="startDate"
            :number-of-days="numberOfDays"
            :window-width="windowWidth"
            @changeCallback="choosePeriodCallback"
          />
          <v-btn
            class="ml-2"
            :color="windowWidth < 1280 ? 'primary' : null"
            :icon="windowWidth < 1280"
            :small="windowWidth < 1280"
            @click="reloadButtonClickEvent"
          >
            <v-icon dark>
              mdi-refresh
            </v-icon>
          </v-btn>
        </h3>
      </v-col>
      <v-col cols="12" md="5" sm="4">
        <div
          v-if="windowWidth >= 1280"
        >
          <v-row dense>
            <v-col>
              <div class="float-left mr-5" style="font-size: 0.8rem">
                <v-icon color="primary" small>mdi-circle-outline</v-icon>&nbsp;受注
              </div>
              <div class="float-left mr-5" style="font-size: 0.8rem">
                <v-icon color="primary" small>mdi-circle-half-full</v-icon>&nbsp;回収済
              </div>
              <div class="float-left mr-5" style="font-size: 0.8rem">
                <v-icon color="primary" small>mdi-circle</v-icon>&nbsp;運搬済
              </div>
              <div class="float-left mr-5" style="font-size: 0.8rem">
                <v-icon color="gray" small>mdi-circle</v-icon>&nbsp;運搬終了報告済
              </div>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <div class="float-left mr-5" style="font-size: 0.8rem">
                <v-icon color="warning" small>mdi-circle-outline</v-icon>&nbsp;受注内容変更
              </div>
              <div class="float-left mr-5" style="font-size: 0.8rem">
                <span class="reservation-square"></span>&nbsp;予約登録前
              </div>
            </v-col>
          </v-row>
        </div>
        <div v-else class="text-right">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                small
              >
                マークについて
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item dense>
                <v-list-item-title>
                  <v-icon color="primary" small>mdi-circle-outline</v-icon>&nbsp;受注
                </v-list-item-title>
              </v-list-item>
              <v-list-item dense>
                <v-list-item-title>
                  <v-icon color="primary" small>mdi-circle-half-full</v-icon>&nbsp;回収済
                </v-list-item-title>
              </v-list-item>
              <v-list-item dense>
                <v-list-item-title>
                  <v-icon color="primary" small>mdi-circle</v-icon>&nbsp;運搬済
                </v-list-item-title>
              </v-list-item>
              <v-list-item dense>
                <v-list-item-title>
                  <v-icon color="gray" small>mdi-circle</v-icon>&nbsp;運搬終了報告済
                </v-list-item-title>
              </v-list-item>

              <v-list-item dense>
                <v-list-item-title>
                  <v-icon color="warning" small>mdi-circle-outline</v-icon>&nbsp;受注内容変更
                </v-list-item-title>
              </v-list-item>

              <v-list-item dense>
                <v-list-item-title>
                  <span class="reservation-square"></span>&nbsp;予約登録前
                </v-list-item-title>
              </v-list-item>

            </v-list>
          </v-menu>
        </div>
      </v-col>
    </v-row>
    <div class="driver-schedule-layout">
      <div class="float-left mr-2 left-block">
        <!-- 検索ブロック -->
        <search-block
          ref="searchBlock"
          :drivers="drivers"
          @callScheduleBlock="callScheduleBlock"
          @disableDriverCallback="disableDriverCallback"
        />
        <!-- /検索ブロック -->
      </div>
      <div class="float-left right-block">
        <!-- 日別スケジュールブロック -->
        <schedule-block
          ref="scheduleBlock"
          :drivers="drivers"
          :start-date="startDate"
          :number-of-days="numberOfDays"
          :disable-driver-ids="disableDriverIds"
          @callSearchBlock="callSearchBlock"
        />
        <!-- /日別スケジュールブロック -->
      </div>
    </div>
  </v-container>
</template>

<style scoped lang="scss">

.driver-schedule-container {
  height: calc(100vh - 135px) !important;
}

// ドライバースケジュール画面レイアウト
.driver-schedule-layout {
  width: 100%;
  overflow: hidden;
  height: 100%;
  display: flex;

  & .left-block {
    width: 200px;
    min-width: 200px;
    height: 100%;
  }
  & .right-block {
    overflow: hidden;
    width: calc(100% - 200px);
    height: 100%;
  }
}

.schedule-title {
  .v-toolbar__content {
    padding-left: 8px;
    padding-right: 12px;
  }
}


.reservation-square {
  display: inline-block;
  width: 20px;
  height: 16px;
  background-color: #fff;
  border: 2px dashed #bdbdbd;
  border-radius: 2px;
  vertical-align: middle;
  margin-right: 4px;
}

</style>
